import * as z$1 from "zod/v4";
//#region src/schemas/http/center-agent-memory.ts
const boundedIdentifierSchema = z$1.string().trim().min(1).max(256);
const CENTER_AGENT_ORGANIZATION_MEMORY_FACT_MAX_CHARS = 1200;
const centerAgentMemoryProviderSchema = z$1.enum(["zep_cloud"]);
const centerAgentMemoryWipeStatusSchema = z$1.enum(["deleted", "not_found"]);
const centerAgentWipeMemberMemoryResponseSchema = z$1.strictObject({
	organizationId: boundedIdentifierSchema,
	provider: centerAgentMemoryProviderSchema,
	status: centerAgentMemoryWipeStatusSchema,
	userId: boundedIdentifierSchema
});
const centerAgentOrganizationMemoryPolicyResponseSchema = z$1.strictObject({
	organizationId: boundedIdentifierSchema,
	organizationMemoryOptIn: z$1.boolean(),
	provider: centerAgentMemoryProviderSchema,
	updatedByUserId: boundedIdentifierSchema.nullable()
});
const updateCenterAgentOrganizationMemoryPolicyBodySchema = z$1.strictObject({ organizationMemoryOptIn: z$1.boolean() });
const centerAgentRememberForOrganizationBodySchema = z$1.strictObject({ fact: z$1.string().trim().min(1).max(CENTER_AGENT_ORGANIZATION_MEMORY_FACT_MAX_CHARS) });
const centerAgentRememberForOrganizationResponseSchema = z$1.strictObject({
	fact: z$1.string().trim().min(1).max(CENTER_AGENT_ORGANIZATION_MEMORY_FACT_MAX_CHARS),
	organizationId: boundedIdentifierSchema,
	saved: z$1.literal(true),
	source: z$1.literal("explicit_tool")
});
//#endregion
export { CENTER_AGENT_ORGANIZATION_MEMORY_FACT_MAX_CHARS, centerAgentMemoryProviderSchema, centerAgentMemoryWipeStatusSchema, centerAgentOrganizationMemoryPolicyResponseSchema, centerAgentRememberForOrganizationBodySchema, centerAgentRememberForOrganizationResponseSchema, centerAgentWipeMemberMemoryResponseSchema, updateCenterAgentOrganizationMemoryPolicyBodySchema };

//# sourceMappingURL=center-agent-memory.js.map